"use client";

import { useFormStatus } from "react-dom";
import { Button } from "@/template/ui-kit/button";
import { signInWithGoogleAction } from "@/core/actions/auth";

function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M21.6 12.227c0-.709-.064-1.39-.182-2.045H12v3.868h5.382a4.6 4.6 0 0 1-1.995 3.018v2.51h3.227c1.886-1.737 2.986-4.295 2.986-7.351Z"
        fill="#4285F4"
      />
      <path
        d="M12 22c2.7 0 4.964-.895 6.618-2.422l-3.227-2.51c-.895.6-2.04.955-3.39.955-2.605 0-4.81-1.76-5.596-4.123H3.073v2.59A9.997 9.997 0 0 0 12 22Z"
        fill="#34A853"
      />
      <path
        d="M6.404 13.9A5.995 5.995 0 0 1 6.09 12c0-.66.114-1.3.314-1.9V7.51H3.073A9.99 9.99 0 0 0 2 12c0 1.614.386 3.14 1.073 4.49l3.331-2.59Z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.977c1.468 0 2.786.505 3.823 1.496l2.867-2.867C16.96 3.012 14.695 2 12 2A9.997 9.997 0 0 0 3.073 7.51l3.331 2.59C7.19 7.736 9.395 5.977 12 5.977Z"
        fill="#EA4335"
      />
    </svg>
  );
}

function SubmitButton({ label }: { label: string }) {
  const { pending } = useFormStatus();
  return (
    <Button
      type="submit"
      variant="outline"
      size="lg"
      disabled={pending}
      className="w-full"
    >
      <GoogleIcon className="size-4" />
      {pending ? "Redirigiendo…" : label}
    </Button>
  );
}

export function GoogleAuthButton({
  next,
  label = "Continuar con Google",
}: {
  next?: string;
  label?: string;
}) {
  return (
    <form action={signInWithGoogleAction} className="w-full">
      {next ? <input type="hidden" name="next" value={next} /> : null}
      <SubmitButton label={label} />
    </form>
  );
}
